import {
    type Block,
    CHILD_OBJECT_INVALID,
    CHILD_TYPE_INVALID,
    NODE_DATA_INVALID,
    PARENT_OBJECT_INVALID,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';

import {
    BLOCK_CODE,
    BLOCK_PROMPT,
    BLOCKS,
    FRAGMENT_EXPANDABLE_BODY,
    FRAGMENT_TABLE_CELL,
} from '../types';
import { unwrapChildren } from '../utils';

/**
 * Schema to validate prompt blocks.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_PROMPT]: {
            parent: {
                objects: ['document', 'fragment', 'block'],
                types: [undefined, ...BLOCKS, FRAGMENT_EXPANDABLE_BODY, FRAGMENT_TABLE_CELL],
            },
            nodes: [{ types: [BLOCK_CODE], min: 1, max: 1 }],
            data: {
                description: (value) => typeof value === 'string',
                icon: (value) => value === undefined || typeof value === 'string',
                openInAIProviders: (value) => value === undefined || typeof value === 'boolean',
                defaultExpanded: (value) =>
                    value === undefined ||
                    value === 'hidden' ||
                    value === 'partial' ||
                    value === 'full',
            },
            normalize: Schema.createNormalize<Block>({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [NODE_DATA_INVALID]: (change, context) => {
                    change.removeDataPathByKey(context.node.key, [context.key]);
                    if (context.key === 'description') {
                        change.setDataByKey(context.node.key, ['description'], '');
                    }
                },
            }),
        },
    },
});
